import type { UserResponse } from 'types/session/user'

import type { RegistryServiceFieldsError } from '../types/registryService'

type SessionRegistryResponse = RegistryServiceFieldsError | UserResponse | null

export const isRegistryFieldsError = (
	registryServiceResponse: SessionRegistryResponse
): registryServiceResponse is RegistryServiceFieldsError =>
	!!(registryServiceResponse as RegistryServiceFieldsError).errorFields
